/**
 * @module virtual-collection/constants
 * DOM selectors, CSS classes, and data attribute keys for the virtual collection form.
 */

export const SELECTORS = {
  submitButton: '.virtual-collection__submit',
  spinner: '.loading__spinner',
  errorWrapper: '.product-form__error-message-wrapper',
  errorMessage: '.product-form__error-message',
  variantData: 'script[data-virtual-collection-variants]',
  addSingleLink: '[data-action="add-single"]',
  productCard: '.virtual-collection__product-card',
  stepperValue: '.virtual-collection__stepper-value',
};

export const CLASSES = {
  loading: 'loading',
  hidden: 'hidden',
};

export const SOURCE = 'virtual-collection-form';
